import React, { useState } from 'react';
import { Star } from '../../../../../UiKit/Star/Star';
import TextEditor from '../../../../../components/serverDrivenUIComponents/TextEditor';
import Button from '../../../../../components/ComponentsV1/Button';
import { isEditorEmpty } from '../constants';

const SopUpdateForm = ({ sopData, onSave, onCancel, isActionLoading }) => {
  const [modelName, setModelName] = useState(
    sopData?.model_name && sopData.model_name !== 'null' ? sopData.model_name : '',
  );
  const [troubleshootingSteps, setTroubleshootingSteps] = useState(
    sopData?.troubleshooting_steps || '',
  );

  const isValid = !isEditorEmpty(troubleshootingSteps);

  const handleSave = () => {
    if (!isValid) return;
    onSave({ modelName: modelName.trim(), troubleshootingSteps });
  };

  return (
    <div className='tw-flex tw-flex-col tw-border tw-border-solid tw-border-[#e5e7eb] tw-rounded-lg tw-p-6 tw-gap-6'>
      <div className='tw-flex tw-w-full tw-gap-5'>
        <div className='tw-flex tw-flex-col tw-h-max tw-gap-5 tw-flex-1'>
          <div className='tw-w-full tw-text-grey-900 tw-font-medium tw-text-500'>
            Model Name
          </div>
          <input
            id='model_name'
            name='model_name'
            placeholder='Enter model name'
            value={modelName}
            onChange={(e) => setModelName(e.target.value)}
            className='tw-appearance-none tw-px-5 tw-py-2 tw-h-16 tw-rounded-lg tw-outline-0 focus:tw-border-none focus:tw-ring-[1.5px] tw-w-full focus:tw-ring-base-green focus:tw-border-base-green tw-border tw-border-solid tw-border-[#cfcfcf]'
            autoComplete='off'
          />
        </div>
      </div>

      <div className='tw-flex tw-flex-col tw-h-max tw-gap-5'>
        <div className='tw-w-full tw-text-grey-900 tw-font-medium tw-text-500'>
         SOPs <Star icon='*' />
        </div>
        <TextEditor
          styleClasses='tw-w-full'
          inputKey='troubleshooting_steps'
          field={{ value: troubleshootingSteps }}
          saveOptions={(_, value) => setTroubleshootingSteps(value)}
          isEditable={true}
          hideSaveButton={true}
        />
      </div>

      <div className='tw-flex tw-gap-4 tw-mt-2'>
        <Button
          title='Save Changes'
          onClick={handleSave}
          disabled={!isValid || isActionLoading}
        />
        <Button
          title='Cancel'
          type='outline'
          onClick={onCancel}
          disabled={isActionLoading}
        />
      </div>
    </div>
  );
};

export default SopUpdateForm;
